angular.module('controllers').controller('callController', ['$scope', '$rootScope', '$controller', '$route', '$routeParams', '$location', 'Crud',
    function ($scope, $rootScope, $controller, $route, $routeParams, $location, Crud) {
        $rootScope.path = '/call';
        $scope.path = $rootScope.path;
        $rootScope.modelName = 'call';
        $scope.pathTemplate = 'calls/calls';
        $scope.title = 'Apeluri telefonice';

        angular.extend(this, $controller('crudController', {$scope: $scope}));

        $scope.sortType = 'id';
        $scope.defaultItem = 10;
        $rootScope.typeId = 'id';
        $scope.search.order = 'asc';
        $scope.classAction = 'td-big';
        $scope.columns = {
            //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
            'call_source':{'label':'Sursa', 'filter':1, 'filterType':'input'},
            'call_destination':{'label':'Destinatie', 'filter':1, 'filterType':'input'},
            'call_price':{'label':'Tarif', 'filter':1, 'filterType':'input'},
            'call_start':{'label':'Start apel', 'filter':1, 'filterType':'input'},
            'call_end':{'label':'Sfarsit apel', 'filter':1, 'filterType':'input'},
            'call_status':{'label':'Status', 'filter':1, 'filterType':'select'},
            'call_record':{'label':'Inregistrare', 'filter':1, 'filterType':'input'}
        };

        $scope.columns.call_status.options = [
            {'id':'', 'value' : ''},
            {'id':0, 'value' : 'Nepreluat'},
            {'id':1, 'value' : 'In curs'},
            {'id':2, 'value' : 'Preluat'},
            {'id':3, 'value' : 'Incheiat'},
            {'id':4, 'value' : 'Reapel'}

        ];

        $scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'call_source';
        $scope.additionals['callStatus'] = $scope.columns.call_status.options;
        $scope.additionals['pathFilesCalls'] = 'calls';//var/calls/

        $scope.maxDate = new Date();
        $scope.minDate = '2010-01-01';
        var current_init_date = new Date();
        current_init_date.setHours(0, 0, 0, 0);
        $scope.search.dateFrom = current_init_date;

        $scope.additionals['play'] = function (modelId) {
            document.getElementById('player'+modelId).play();
        }
        $scope.additionals['pause'] = function (modelId) {
            document.getElementById('player'+modelId).pause();
        }

    }]
);
